// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function callback_request_response_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var result = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "result"), null));
  if (result.TAG === /* Ok */0) {
    var prev_callback_req_id_present = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "prev_callback_req_id_present"), null));
    if (prev_callback_req_id_present.TAG === /* Ok */0) {
      var callback_request_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback_request_id"), null));
      if (callback_request_id.TAG === /* Ok */0) {
        var is_existing_cust = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_existing_cust"), null));
        if (is_existing_cust.TAG === /* Ok */0) {
          var brand = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
          if (brand.TAG === /* Ok */0) {
            var lead_entry_created = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lead_entry_created"), null));
            if (lead_entry_created.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        result: result._0,
                        prev_callback_req_id_present: prev_callback_req_id_present._0,
                        callback_request_id: callback_request_id._0,
                        is_existing_cust: is_existing_cust._0,
                        brand: brand._0,
                        lead_entry_created: lead_entry_created._0
                      }
                    };
            }
            var e = lead_entry_created._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".lead_entry_created" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = brand._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".brand" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = is_existing_cust._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_existing_cust" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = callback_request_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".callback_request_id" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = prev_callback_req_id_present._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".prev_callback_req_id_present" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = result._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".result" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function vehicle_dimensions_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
  if (value.TAG === /* Ok */0) {
    var unit = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "unit"), null));
    if (unit.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                value: value._0,
                unit: unit._0
              }
            };
    }
    var e = unit._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".unit" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function base_fare_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
  if (value.TAG === /* Ok */0) {
    var currency = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency"), null));
    if (currency.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                value: value._0,
                currency: currency._0
              }
            };
    }
    var e = currency._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".currency" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function vehicle_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var display_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "display_name"), null));
  if (display_name.TAG === /* Ok */0) {
    var vehicle_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
    if (vehicle_type.TAG === /* Ok */0) {
      var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
      if (vehicle_id.TAG === /* Ok */0) {
        var image_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_url"), null));
        if (image_url.TAG === /* Ok */0) {
          var image_alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_alt_text"), null));
          if (image_alt_text.TAG === /* Ok */0) {
            var capacity_display = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity_display"), null));
            if (capacity_display.TAG === /* Ok */0) {
              var size_display = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size_display"), null));
              if (size_display.TAG === /* Ok */0) {
                var base_fare_display = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare_display"), null));
                if (base_fare_display.TAG === /* Ok */0) {
                  var base_fare = base_fare_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare"), null));
                  if (base_fare.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              display_name: display_name._0,
                              vehicle_type: vehicle_type._0,
                              vehicle_id: vehicle_id._0,
                              image_url: image_url._0,
                              image_alt_text: image_alt_text._0,
                              capacity_display: capacity_display._0,
                              size_display: size_display._0,
                              base_fare_display: base_fare_display._0,
                              base_fare: base_fare._0
                            }
                          };
                  }
                  var e = base_fare._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".base_fare" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = base_fare_display._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".base_fare_display" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = size_display._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".size_display" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = capacity_display._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".capacity_display" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = image_alt_text._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".image_alt_text" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = image_url._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".image_url" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = vehicle_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vehicle_id" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = vehicle_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_type" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = display_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".display_name" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var callback_request_response = callback_request_response_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback_request_response"), null));
  if (callback_request_response.TAG === /* Ok */0) {
    var vehicles = Decco.arrayFromJson(vehicle_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicles"), null));
    if (vehicles.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                callback_request_response: callback_request_response._0,
                vehicles: vehicles._0
              }
            };
    }
    var e = vehicles._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicles" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = callback_request_response._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".callback_request_response" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  callback_request_response_decode ,
  vehicle_dimensions_decode ,
  base_fare_decode ,
  vehicle_decode ,
  t_decode ,
}
/* No side effect */
